import React from 'react';
import styled from 'styled-components';
import { observer } from "mobx-react-lite";
import { LineGestureModel } from '../../../shared/combat/gestures/LineGestureModel';
import { CircleGestureModel } from '../../../shared/combat/gestures/CircleGestureModel';
import { gameCanvasSize } from "../../data/gameConstants";
import { gesturePatternViewOffset, screenToPatternCoordinatesFactor } from '../../stores/CombatStore';
const SvgWithoutBaseline = styled.svg.withConfig({
  displayName: "GesturePatternPreview__SvgWithoutBaseline",
  componentId: "sc-7r1gig-0"
})(["vertical-align:top;"]);
export const GesturePreview = observer(({
  gesture,
  offsetX,
  offsetY,
  scale
}) => {
  const gestureScale = scale * screenToPatternCoordinatesFactor;

  if (gesture instanceof LineGestureModel) {
    return /*#__PURE__*/React.createElement("line", {
      x1: offsetX + gesture.from.x * gestureScale,
      y1: offsetY + gesture.from.y * gestureScale,
      x2: offsetX + gesture.to.x * gestureScale,
      y2: offsetY + gesture.to.y * gestureScale,
      stroke: "black",
      strokeWidth: 2
    });
  }

  if (gesture instanceof CircleGestureModel) {
    return /*#__PURE__*/React.createElement("circle", {
      cx: offsetX + gesture.center.x * gestureScale,
      cy: offsetY + gesture.center.y * gestureScale,
      r: gesture.radius * gestureScale,
      stroke: "black",
      strokeWidth: 2,
      fill: "none"
    });
  }

  throw new Error("Not implemented");
});
export const GesturePatternPreview = observer(({
  gesturePattern,
  width
}) => {
  if (!gesturePattern) return null;
  const scale = width / gameCanvasSize.width;
  const height = gameCanvasSize.height * scale;
  const offsetX = scale * gesturePatternViewOffset.x;
  const offsetY = scale * gesturePatternViewOffset.y;
  return /*#__PURE__*/React.createElement(SvgWithoutBaseline, {
    width: width,
    height: height
  }, /*#__PURE__*/React.createElement("rect", {
    width: width,
    height: height,
    stroke: "black",
    strokeWidth: 2,
    fill: "white"
  }), gesturePattern.gestures.map(gesture => /*#__PURE__*/React.createElement(GesturePreview, {
    key: gesture.$modelId,
    gesture: gesture,
    offsetX: offsetX,
    offsetY: offsetY,
    scale: scale
  })));
});